import firebase from 'firebase/app';
import 'firebase/firebase-messaging';

var firebaseConfig = {
    apiKey: 'AIzaSyC1mlP8hSGL5od8_vfsMX1uq-E1GxoedvU',
    authDomain: 'tcdeliveries-25e68.firebaseapp.com',
    databaseURL: 'https://tcdeliveries-25e68.firebaseio.com',
    projectId: 'tcdeliveries-25e68',
    storageBucket: 'tcdeliveries-25e68.appspot.com',
    messagingSenderId: '792044377240',
    appId: '1:792044377240:web:5dc40562f2ed024b56aced',
    measurementId: 'G-QEQKPBP6CB'
};

firebase.initializeApp(firebaseConfig);
export default firebase.messaging();
